import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from '@platzona/ui';
import { initI18n } from './i18n';
import App from './App';
import { installEarlyBeforeInstallPromptCapture } from './pwa/earlyInstallPrompt';
import { registerPlatzonaServiceWorker } from '@platzona/offline';
import './index.css';
import './styles/mobile-shell.css';
import './styles/sticky-modal-shell.css';
import '@platzona/ui/platform-shell.css';

// Must run before React: Freigabe BIP often fires during first paint.
installEarlyBeforeInstallPromptCapture();

function registerServiceWorker() {
  // Skipped in dev: a cached app shell fighting Vite's own HMR/module reloads is a worse
  // experience than no offline support at all while iterating locally.
  // Auto-updates + one reload when a new SW takes control (stale Freigabe shells).
  if (import.meta.env.DEV) return;
  registerPlatzonaServiceWorker('/sw.js');
}

async function bootstrap() {
  await initI18n();
  registerServiceWorker();
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <Suspense fallback={null}>
          <App />
        </Suspense>
      </ErrorBoundary>
    </React.StrictMode>
  );
}

void bootstrap();
